import { motion } from "framer-motion";
import { useState } from "react";
import { Plus } from "lucide-react";

const ITEMS = [
  {
    q: "Ist BeParent wirklich vollständig offline nutzbar?",
    a: "BeParent ist offline nutzbar und speichert Falldaten primär auf deinem Gerät. Für Login, Zugriffsschutz, Lizenzierung und gegebenenfalls die Geräteverwaltung besteht ein separates Account-System. Optionale Backups werden bereits auf deinem Gerät verschlüsselt, bevor sie übertragen werden. BeParent erhält keinen Zugriff auf die unverschlüsselten Inhalte deiner Fallakte.",
  },
  {
    q: "Für wen ist BeParent geeignet?",
    a: "Für Eltern in familienrechtlichen Verfahren, sowie deren Anwälte, das Jugendamt, Verfahrensbeistände, Mediator:innen, Familienhelfer:innen und Gerichte. Die Datenstruktur bleibt neutral — unabhängig davon, wer sie liest.",
  },
  {
    q: "Wie funktioniert die Musteranalyse?",
    a: "BeParent erkennt Häufungen, wiederkehrende Ereignisse und zeitliche Muster in deinen dokumentierten Einträgen. Die Auswertung der Falldaten erfolgt lokal und wertungsfrei.",
  },
  {
    q: "Kann ich Berichte für Anwälte oder Gerichte exportieren?",
    a: "Ja. Berichte werden als strukturierte, signierte PDF-Fallakte exportiert — mit SHA-256 Prüfsumme und optionaler Passwortverschlüsselung.",
  },
  {
    q: "Was passiert, wenn ich mein Gerät verliere?",
    a: "Je nach Einstellung kann BeParent per Gerätebiometrie oder Geräte-PIN vor unbefugtem Zugriff geschützt werden. Optional lässt sich ein Backup erstellen, das vor der Übertragung clientseitig verschlüsselt wird. So kann die Fallakte nach einem Geräteverlust aus einer vorhandenen Sicherung wiederhergestellt werden, ohne dass BeParent Zugriff auf die unverschlüsselten Inhalte erhält.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-14">
          <span className="font-mono-bp text-[11px] tracking-[0.35em] uppercase text-[#00FAF8]">
            FAQ
          </span>
          <span className="flex-1 h-px bg-gradient-to-r from-[#00FAF8]/40 via-white/10 to-transparent" />
          <span className="font-mono-bp text-[11px] tracking-[0.25em] uppercase text-white/40">
            Häufige Fragen
          </span>
        </div>

        <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.03em] font-medium mb-14">
          Klarheit. <span className="text-white/40">In Sachen Datenschutz.</span>
        </h2>

        <div className="divide-y divide-white/5 border-y border-white/5">
          {ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left group"
                >
                  <div className="flex items-start gap-5">
                    <span className="mt-1 font-mono-bp text-[11px] text-[#00FAF8] tracking-widest">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-display text-white text-xl md:text-2xl tracking-tight group-hover:text-[#00FAF8] transition-colors">
                      {item.q}
                    </h3>
                  </div>
                  <span
                    className={`shrink-0 mt-1 inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 transition-transform ${
                      isOpen ? "rotate-45 border-[#00FAF8]/60" : ""
                    }`}
                  >
                    <Plus size={16} className={isOpen ? "text-[#00FAF8]" : "text-white/70"} />
                  </span>
                </button>
                <motion.div
                  initial={false}
                  animate={{
                    height: isOpen ? "auto" : 0,
                    opacity: isOpen ? 1 : 0,
                  }}
                  transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <div className="pb-8 pl-12 pr-4 max-w-3xl">
                    <p className="text-white/60 text-[15px] md:text-base leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
